import { SpgPricingType } from '../../../API/Enums';
import { MinEstCostFunction } from './minEstCost.types';

/**
 * Returns the minimum price of a service, or null if non-existent.
 */
export const minEstCost: MinEstCostFunction = (service) => {
    // non-SPG-priced service
    if (('useSpgPricing' in service && !service.useSpgPricing) || ('isSpgOp' in service && !service.isSpgOp)) {
        // For non-SPG-priced services, we don't want "Ask Me About Pricing" to show
        return service.price ?? 0;
    }
    else if ('spgPricing' in service) {
        switch (service.spgPricing) {
            case SpgPricingType.NoPrice:
                return null;
            case SpgPricingType.Range:
            case SpgPricingType.Minimum:
                return service.priceLow ?? ('price' in service ? service.price : null) ?? null;
            case SpgPricingType.Maximum:
                return service.priceHigh ?? ('price' in service ? service.price : null) ?? null;
        }
    }

    return null;
};
